import { ComponentsModule } from '../../components/components.module';
import { ServicesModule } from '../../services/services.module';
import { CandidateProfilePageModule } from './candidateprofile/candidate-profile-page.module';
import { RequisitionsPageModule } from './requisitions/requisitions-page.module';
import { CandidateJobMatchesWorkflowPageModule } from './candidateJobMatchesWorkflow/candidate-job-matches-workflow-page.module';
import { EditSharedReqPageModule } from './sharedReqRestrictedEdit/shared-req-restricted-edit-page.module';
import { AddEditUserPageModule } from './addEditUser/add-edit-user-page.module';
import { CompanyPageModule } from './company/company-page.module';
import { SettingsPageModule } from './settings/settings-page.module';
import { AddCandidatesPageModule } from './addCandidates/add-candidates-page.module';
import { UploadReqPageModule } from './uploadreq/upload-req-page.module';
import { CandidatesPageModule } from './candidates/candidates-page.module';
import { ConferencePageModule } from './conference/conference-page.module';
import { MissionControlComponent } from './mission-control.component';
import { NotProcessedCandidatesModule } from './notprocessedcandidates/not-processed-candidates.module.js';
import './index.js';
import { RoleEntityScopePageAjsModule } from 'src/app/pages/mission-control-page/role-entity-scope-page/role-entity-scope-page-ajs.module';
import { ChangePasswordPageAjsModule } from 'src/app/pages/mission-control-page/change-password-page/change-password-page-ajs.module';
import { DashboardPageAjsModule } from 'src/app/pages/mission-control-page/dashboard-page/dashboard-page.module-ajs';
import { ManageSkillsPageAjsModule } from 'src/app/pages/mission-control-page/manage-skills-page/manage-skills-page.module-ajs';
import { EmployeeManagementPageModuleAjsModule } from 'src/app/pages/mission-control-page/employee-management-page/employee-management-page.module-ajs';
import { EmployeesPageAjsModule } from 'src/app/pages/mission-control-page/employees-page/employees-page.module-ajs';
import { BulkUploadPageModuleAjsModule } from 'src/app/pages/mission-control-page/bulk-upload-page/bulk-upload-page.module-ajs';
import { AssessmentsManagementAjsModule } from 'src/app/pages/mission-control-page/assessments-management/assessments-management-ajs.module';
import { ClientOrBusPageAjsModule } from 'src/app/pages/mission-control-page/client-or-bus-page/client-or-bus-page.module-ajs';
import { NotificationsPageAjsModule } from 'src/app/pages/mission-control-page/notifications-page/notifications-page.module-ajs';
import { NotificationPreferencePageAjsModule } from 'src/app/pages/mission-control-page/notification-preference-page/notification-preference-page.module-ajs';
import { ManageRequisitionEntitiesAjsPageModule } from 'src/app/pages/mission-control-page/manage-requisition-entities-page/manage-requisition-entities-page.module-ajs';
import { ManageMasterListsPageAjsPageModule } from 'src/app/pages/mission-control-page/manage-master-lists-page/manage-master-lists-page.module-ajs';
import { JobProfilePageAjsModule } from 'src/app/pages/mission-control-page/job-profile-page/job-profile-page.module-ajs';
import { FeedbackFormsPageAjsModule } from 'src/app/pages/mission-control-page/feedback-forms-page/feedback-forms-page-ajs.module';
import { VendorsPageAjsModule } from 'src/app/pages/mission-control-page/vendors-page/vendors-page-ajs.module';
import { CandidateOutreachPageAjsModule } from 'src/app/pages/mission-control-page/candidate-outreach-page/candidate-outreach-page.module-ajs';
import { AiActivitiesPageAjsModule } from 'src/app/pages/mission-control-page/ai-activities-page/ai-activities-page.module-ajs';
import { TeamMembersPageModuleAjsModule } from 'src/app/pages/mission-control-page/team-members-page/team-memebers-page-ajs.module';
/**
 * This module is a Parent for all Mission Control Functionalities
 * (or Pages).This Module is maintained just for maintaining
 * Separation of Concern. Gives Easy maintenance if in future
 * 4dot5 has another major Responsibilities.
 */
export var MissionControlModule = angular
    .module('4dot5.missioncontrolmodule', [
    AddEditUserPageModule,
    CompanyPageModule,
    AddCandidatesPageModule,
    UploadReqPageModule,
    CandidatesPageModule,
    CandidateJobMatchesWorkflowPageModule,
    CandidateProfilePageModule,
    // '4dot5.missioncontrolmodule.auditlogsmodule',
    RequisitionsPageModule,
    '4dot5.missioncontrolmodule.reportsmodule',
    '4dot5.missioncontrolmodule.candidateperformancemodule',
    '4dot5.missioncontrolmodule.reportsmodule.corporateorclientreportmodule',
    // '4dot5.missioncontrolmodule.notprocessedcandidatesmodule',
    NotProcessedCandidatesModule,
    // '4dot5.missioncontrolmodule.transactionsmodule',
    SettingsPageModule,
    EditSharedReqPageModule,
    ComponentsModule,
    ServicesModule,
    ConferencePageModule,
    //Migrated
    ChangePasswordPageAjsModule,
    RoleEntityScopePageAjsModule,
    DashboardPageAjsModule,
    ManageSkillsPageAjsModule,
    EmployeeManagementPageModuleAjsModule,
    EmployeesPageAjsModule,
    BulkUploadPageModuleAjsModule,
    AssessmentsManagementAjsModule,
    ClientOrBusPageAjsModule,
    NotificationsPageAjsModule,
    NotificationPreferencePageAjsModule,
    ManageRequisitionEntitiesAjsPageModule,
    ManageMasterListsPageAjsPageModule,
    JobProfilePageAjsModule,
    FeedbackFormsPageAjsModule,
    VendorsPageAjsModule,
    CandidateOutreachPageAjsModule,
    AiActivitiesPageAjsModule,
    TeamMembersPageModuleAjsModule
])
    .config(['$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('missioncontrol', {
            url: '/missioncontrol',
            component: MissionControlComponent.selector,
            data: {
                requireLogin: true,
                companyObject: null,
                companyDeletedShowPopup: null
            }
        });
    }
])
    .component(MissionControlComponent.selector, MissionControlComponent.component)
    .name;
//# sourceMappingURL=mission-control.module.js.map